import { get } from 'lodash';
import constants from '../constants';

export class TruckSeal {
  constructor() {
    this.next = null;
  }

  setNext(handler) {
    this.next = handler;
    return handler;
  }

  handle(params) {
    const { token, context } = params;

    if (token.includes(`${constants.TRUCK_SEAL}`)) {
      const getTruckSealValue = container => container?.vehicle?.truckSeal;
      const splitContainers = get(context, 'containers', {});

      if (Object.keys(splitContainers).length > 0) {
        const values = Object.values(splitContainers)
          .map(getTruckSealValue)
          .filter(v => v !== undefined && v !== null && v !== '');

        return values.length > 0 ? values[0] : '';
      }

      const defaultContainer = get(splitContainers, '[0]', {});
      const seal = getTruckSealValue(defaultContainer);

      return seal !== undefined && seal !== null ? seal : '';
    }

    return this?.next?.handle?.(params);
  }
}
